import type { ReactElement } from "react";
import { toast } from "sonner";

import type { ToastPrimitiveOptions } from "./types";

export const toastPrimitive = {
  custom(node: ReactElement, options: ToastPrimitiveOptions) {
    if (typeof window === "undefined") return "";
    return toast.custom(() => node, options);
  },
  dismiss(id?: string | number) {
    if (typeof window === "undefined") return;
    toast.dismiss(id);
  },
};
